import { BiteBrand } from "./bite-brand";
import { BiteHeaderNav, type BiteHeaderNavItem } from "./bite-header-nav";
import {BiteButton,BiteLinkButton} from './bite-ui';

interface BiteSiteHeaderProps {
  mode: string;
  current?: BiteHeaderNavItem;
  guestAction?:()=>void;
  guestHref?:string;
  guestLabel?:string;
}

export function BiteSiteHeader({ mode, current, guestAction,guestHref,guestLabel }: BiteSiteHeaderProps) {
  return (
    <header className="bite-site-header">
      <div className="bite-site-header__inner">
        <BiteBrand mode={mode} />
        {guestHref?<BiteLinkButton size="sm" href={guestHref} data-track="bite.landing.header.start">{guestLabel||"지금 바로 시작하기"}</BiteLinkButton>:guestAction?<BiteButton size="sm" onClick={guestAction}>지금 바로 시작하기</BiteButton>:<BiteHeaderNav current={current} />}
      </div>
    </header>
  );
}
